<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Chapter-Title-Page-Break">PREFACE</p>
<p class="ORIM-Chapter-Opener-Paragraph">The initial idea of the compilation of this work was to give the reading public an authentic record of the private life of the Apache Indians, and to extend to Geronimo as a prisoner of war the courtesy due any captive, <span class="ORIM-Ital">i. e.</span>, the right to state the causes which impelled him in his opposition to our civilization and laws.</p>
<p class="ORIM-Body-Text">If the Indians’ cause has been properly presented, the captives’ defense clearly stated, and the general store of information regarding vanishing types increased, I shall be satisfied.</p>
<p class="ORIM-Body-Text">I desire to acknowledge valuable suggestions from Maj. Charles Taylor, Fort Sill, Oklahoma; Dr. J. M. Greenwood, Kansas City, Missouri, and President David R. Boyd, of the University of Oklahoma.</p>
<p class="ORIM-Body-Text">I especially desire in this connection to say that without the kindly advice and assistance of President Theodore Roosevelt this book could not have been written.</p>
<p class="ORIM-Body-Text-Right">Respectfully,</p>
<p class="ORIM-Body-Text-Right">S. M. Barrett.</p>
<p class="ORIM-Body-Text-Right">Lawton, Oklahoma.<br/><span class="ORIM-Ital">August 14, 1906</span>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled12.vue?70203910